




import { Component } from 'vue-property-decorator'

// store
import AuthModule from '@/store/modules/auth'
import { AuthToken } from '@/store/types'
// mixins
import NotifyMixin from '@/mixins/NotifyMixin'

@Component
export default class RegistrationGiveaway extends NotifyMixin {
  private form: AuthToken = {
    token: '',
  }

  private created() {
    if (!this.$route.params.token) {
      this.$router.replace({ name: 'auth.login' })
      this.notifyError('Некорректный токен подтверждения')
    } else {
      this.form.token = this.$route.params.token
      this.handleSubmit()
    }
  }

  private handleSubmit () {
    if (AuthModule.self) {
      AuthModule.logout()
        .then(() => {
          this.registerConfirmation()
        })
        .catch(this.notifyError)
    }
    this.registerConfirmation()
  }

  private registerConfirmation() {
    AuthModule.registrationGiveawayConfirmation(this.form)
      .then(() => {
        this.$router.push({ name: 'master' })
      })
      .catch(this.notifyError)
  }
}
